import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../app/store/store';
import {
  fetchHelpdeskSettings,
  updateHelpdeskSettings,
} from '../../../entities/helpdesk-settings/model';
import { SettingsToggleWithInput } from '@shared/ui/settings-toggle';

const StatusCloseSettings: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { settings, status } = useSelector(
    (state: RootState) => state.helpdeskSettings,
  );

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchHelpdeskSettings());
    }
  }, [dispatch, status]);

  const handleUpdate = useCallback(
    (field: string, value: boolean | number) => {
      dispatch(updateHelpdeskSettings({ [field]: value }));
    },
    [dispatch],
  );

  if (status === 'loading' || !settings) {
    return (
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <div className="animate-pulse space-y-4">
          <div className="h-5 bg-gray-200 rounded w-1/3"></div>
          <div className="h-12 bg-gray-100 rounded"></div>
          <div className="h-12 bg-gray-100 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-0">
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-[#2d2c2c] mb-4">
          Автоматическое закрытие заявок
        </h2>

        <div className="divide-y divide-gray-100">
          <SettingsToggleWithInput
            label='Автоматически закрывать заявки со статусом "Решена"'
            description="Если клиент не ответил в течение указанного времени"
            checked={settings.auto_close_enabled}
            onToggle={(v) => handleUpdate('auto_close_enabled', v)}
            value={settings.auto_close_days}
            onValueChange={(v) => handleUpdate('auto_close_days', v)}
            prefix="Через"
            unit="дней"
          />

          <SettingsToggleWithInput
            label="Уведомить клиента перед автозакрытием"
            description="Email-уведомление за N дней до автоматического закрытия"
            checked={settings.warn_before_close_enabled}
            onToggle={(v) => handleUpdate('warn_before_close_enabled', v)}
            value={settings.warn_before_close_days}
            onValueChange={(v) => handleUpdate('warn_before_close_days', v)}
            prefix="За"
            unit="дня"
          />
        </div>
      </div>
    </div>
  );
};

export default StatusCloseSettings;
